// Backend returns an event's court as a nested object ({ id, name, court_type })
// for multi-court venues (see _serialize_court). Legacy/empty events may still
// send a plain string (court_label) or null. Rendering the raw object as a
// React child throws "Objects are not valid as a React child", so always pass
// court values through here before rendering.
export type CourtValue =
  | { id?: string; name?: string | null; court_label?: string | null; court_type?: string | null }
  | string
  | number
  | null
  | undefined

export const getCourtName = (court: CourtValue): string => {
  if (court == null) return ''
  if (typeof court === 'string' || typeof court === 'number') return String(court)
  return court.name ?? court.court_label ?? ''
}

export const getCourtDisplayName = (court: CourtValue): string => {
  const name = getCourtName(court)
  if (!name) return ''
  return /^court\b/i.test(name) ? name : `Court ${name}`
}

export default getCourtName
